import { CleanPurchaseOrder } from '../../../export-types/cleaned-types';
import { useIntl } from 'react-intl';
import { InputWrapper } from '../../common/input-wrapper';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { getPrefixByType } from '../../common/cards/id-cell-card.component';
import { usePurchaseCustomsOrders } from '../../../services/purchase-order.service';

export function PurchaseOrderRelatedCustoms(props: {
  order: CleanPurchaseOrder;
}) {
  const intl = useIntl();

  const { data: customsOrders } = usePurchaseCustomsOrders(props.order.id);

  return (
    <>
      {
        <InputWrapper
          theme="light"
          className="mt-3"
          title={intl.formatMessage({
            defaultMessage: 'Связанные заказы',
            id: 'PurchaseOrderRelatedCustoms.label-input.customs',
            description: 'Информация о связанных посылках',
          })}
        >
          {customsOrders?.map((customsOrder, index) => {
            return (
              <NavLink to={`/customs-deliveries/order/${customsOrder.id}`}>
                {getPrefixByType('customs')}
                {customsOrder.internalId}
                {index !== (customsOrders?.length || 0) - 1 ? '; ' : ''}
              </NavLink>
            );
          })}
        </InputWrapper>
      }
    </>
  );
}
